<template>
    <div class="check-result border-1px">
      <div class="box" v-if="status === 'checking'">
        <img src="@/assets/images/checking.png" alt="" class="icon">
        <div class="title">等待审核</div>
        <div class="txt">您的认证信息已提交，我们会尽力在5个工作日内完成审核（特殊情况可能延迟），结果将通过短信或邮件通知。</div>
      </div>
      <div class="box" v-if="status === 'fail'">
        <img src="@/assets/images/check-fail.png" alt="" class="icon">
        <div class="title">审核失败</div>
        <div class="txt">失败原因失败原因失败原因失败原因失败原因失败原因失败原因失败原因失败原因失败原因失败原因失败原因失败原因失败原因失败原因失 败原因失败原因失败原因失败原因。</div>
      </div>
      <div class="success-box" v-if="status === 'success'">
        <div class="success-box-header">
          <img src="@/assets/images/check-success.png" alt="" class="icon">
          <div class="success-title">恭喜！您的账号已通过实名认证</div>
        </div>
        <ul class="success-box-content border-1px">
          <li class="line title">认证信息</li>
          <li class="line" v-for="(item,index) in successData" :key="index">
            <div class="line-key">{{item.key}}</div>
            <div class="line-value">{{item.value}}</div>
          </li>
        </ul>
      </div>
    </div>
</template>

<script>
    export default {
        name: 'check-result',
        components: {},
        data() {
            return {
                successData: [
                    { key: '证件姓名', value: '张三' },
                    { key: '英语姓名/姓名拼音', value: 'liang hu' },
                    { key: '证件类型', value: '身份证' },
                    { key: '证件号码', value: '6374888783736622828288282' },
                    { key: '国籍', value: '中国大陆' },
                    { key: '性别', value: '男' },
                ],
            };
        },
        props: {
            status: {
                type: String,
                default: 'checking',
            },
        },
        watch: {},
        computed: {},
        created() {
        },
        mounted() {
        },
        destroyed() {
        },
        methods: {},
    };
</script>

<style lang="stylus" scoped>
@import "check-result.styl"
</style>
